export default __webpack_public_path__ + "static/backend-as-a-service-1-a26eae65ef0cc8ebc30e366597810641.png";